import { TransitionService } from '@uirouter/angularjs';
import { AuthService } from '../../core/services/auth/auth.service';

export function authGuard( $transitions: TransitionService,
                           authService: AuthService ) {
  $transitions.onEnter({ to: 'app.public.auth.**' }, ( transition ) => {
    const $state = transition.router.stateService;
    if ( authService.isLoggedIn() ) {
      return $state.target('app.dashboard.profile');
    }
  });
}

authGuard.$inject = [
  '$transitions',
  'AuthService'
];



// WEBPACK FOOTER //
// ./app/states_mobile/auth/auth.guard.ts